import { Stack } from 'ui-components';
import { Child, CreditCard, Preferences, Silent } from './icons';
import { twJoin } from 'tailwind-merge';
import { BasicCustomerFragment, CompleteBookingFragment } from 'drycut-graphql';

type Props = {
  booking: CompleteBookingFragment;
  customer: BasicCustomerFragment;
  size?: 'small' | 'large';
  showPreferencesIcon?: boolean;
};

export function CustomerBookingIcons({
  booking,
  customer,
  size = 'large',
  showPreferencesIcon = true,
}: Props): React.ReactElement {
  const defaultClasses = 'white border-2 rounded-full p-1 fill-white';
  const classesWithSize = twJoin(defaultClasses, size === 'small' ? 'w-6 h-6' : 'w-8 h-8');

  const kidsPrice = booking?.paymentTransaction?.data?.kidCustomer || false;
  const amount = booking?.paymentTransaction?.amount || 0;
  const manual = booking?.manual || false;
  const couponUsed = !!booking?.coupon;
  const silentBooking = booking?.paymentTransaction?.data?.silentBooking || false;
  const submittedPreferences = customer?.preferences?.submittedPreferences || false;

  return (
    <Stack direction="row" className="-space-x-3">
      {manual && <CreditCard className={twJoin(classesWithSize, 'bg-rose-500')} />}
      {kidsPrice && <Child className={twJoin(classesWithSize, 'bg-sky-400')} />}
      {silentBooking && <Silent className={twJoin(classesWithSize, 'bg-zinc-500')} />}
      {submittedPreferences && showPreferencesIcon && (
        <Preferences className={twJoin(classesWithSize, 'bg-green-400')} />
      )}
      {couponUsed && manual && (
        <div className={twJoin(classesWithSize, 'flex items-center justify-center bg-sky-200')}>
          {amount}
        </div>
      )}
    </Stack>
  );
}
